import _kebabCase from 'lodash/kebabCase';

import {
    Google,
    GoogleTransformers,
} from 'reaxl-analytics-handlers';

import getInventoryOwnerById from '@/analytics/utilities/getInventoryOwnerById';

export function ownerPhoneNumberImpressions(metadata, option) {
    const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

    const { data, state, dataLayer } = metadata;
    const { inventoryId, linkText } = data;
    const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
    // replace whitespace with dash character,then remove anything that is not a word or dash character, and turn string to lowercase
    const linkCopy = _kebabCase(linkText) ?? 'get-this-sellers-phone-number';
    Google.sendImpressions(metadata, {
        eventElement: 'dealer',
        eventResult: `text-link::${linkCopy}`,
        eventData: {
            vehicle: {
                ...googleInventoryTransformer(inventoryWithOwner, { target: 'vehicle', dataLayer }),
            },
        },
    }, option);

    return {};
}

export default {
    ownerPhoneNumberImpressions,
};
